import { FEATURE_FLAGS, SKILL_LEVELS } from '@/constants';
import { cva } from 'class-variance-authority';

const isV2 = FEATURE_FLAGS.ENABLE_SCORECARD_V2;

/**
 * Base styles for the skill level scale component
 */
export const skillLevelScaleStyles = cva('skilllevelscale w-full', {
  variants: {
    size: {
      small: 'text-xs',
      medium: 'text-sm',
      large: 'text-base',
    },
  },
  defaultVariants: {
    size: 'small',
  },
});

/**
 * Progress bar styles for the skill level scale
 */
export const progressBarStyles = cva(
  'relative rounded-full transition-all duration-300 bg-neutral-gray-200',
  {
    variants: {
      size: {
        small: 'h-2.5',
        medium: 'h-3',
        large: 'h-3',
      },
    },
    defaultVariants: {
      size: 'small',
    },
  },
);

/**
 * Fill bar styles for different skill levels
 */
export const fillBarStyles = cva('h-full rounded-full transition-all duration-300 ease-in-out', {
  variants: {
    level: {
      none: 'bg-neutral-gray-300',
      // Canonical codes
      [SKILL_LEVELS.AWARENESS]: 'bg-semantic-score-l1',
      [SKILL_LEVELS.SKILLED]: 'bg-semantic-score-l2',
      [SKILL_LEVELS.ADVANCED]: 'bg-semantic-score-l3',
      [SKILL_LEVELS.EXPERT]: 'bg-semantic-score-l4',
      // Legacy aliases mapped to same colors depending on feature flag
      [SKILL_LEVELS.BEGINNER]: isV2 ? 'bg-semantic-score-l1' : 'bg-semantic-score-legacy-l1',
      [SKILL_LEVELS.NOVICE]: isV2 ? 'bg-semantic-score-l1' : 'bg-semantic-score-legacy-l1',
      [SKILL_LEVELS.INTERMEDIATE]: isV2 ? 'bg-semantic-score-l2' : 'bg-semantic-score-legacy-l2',
    },
  },
  defaultVariants: {
    level: 'none',
  },
});

/**
 * Container query breakpoints for responsive design
 */
export const containerQuery = {
  'width-between-400-and-599': {
    minWidth: 400,
    maxWidth: 599,
  },
  'width-larger-than-600': {
    minWidth: 600,
  },
};
